import axios from '../axios';
import { IOffer } from '../interfaces/domain';

export const getOffers = async (offerRequestId?: string, serviceProviderId?: string): Promise<IOffer[]> => {
  const params = new URLSearchParams();
  if (offerRequestId) params.append('offerRequestId', offerRequestId);
  if (serviceProviderId) params.append('serviceProviderId', serviceProviderId);
  const qs = params.toString();
  const url = qs ? `/json/offers?${qs}` : '/json/offers';
  const response = await axios.get(url);
  return response.data;
};

export const getOffer = async (id: string): Promise<IOffer> => {
  const response = await axios.get(`/json/offers/${id}`);
  return response.data;
};

export const saveOffer = async (offer: IOffer): Promise<IOffer> => {
  const response = await axios.post('/json/offers', offer);
  return response.data;
};

export const updateOffer = async (id: string, offer: Partial<IOffer>): Promise<IOffer> => {
  const response = await axios.put(`/json/offers/${id}`, offer);
  return response.data;
};

export const deleteOffer = async (id: string): Promise<void> => {
  await axios.delete(`/json/offers/${id}`);
};

export const generateAiDraft = async (
  offerRequestId: string, 
  offerData?: Partial<IOffer>, 
  customPrompt?: string
): Promise<string> => {
  const payload: any = offerData ? { offerRequestId, ...offerData } : { offerRequestId };
  if (customPrompt !== undefined && customPrompt !== null) {
    payload.customPrompt = customPrompt;
  }
  const response = await axios.post('/json/offers/generate-ai-draft', payload);
  return response.data.draft;
};

const OfferService = {
  getOffers,
  getOffer,
  saveOffer,
  updateOffer,
  deleteOffer,
  generateAiDraft
};

export default OfferService;
